(function(){
  // 标记当前页面为 HS26 落地页（只在该页面引入本 JS 时生效）
  function mark(){
    try{
      document.documentElement.classList.add('hs26-landing');
      if(document.body) document.body.classList.add('hs26-landing');
    }catch(e){}
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', mark);
  }else{
    mark();
  }
})();

(function(){
  function moveFixedLayers(){
    var els=document.querySelectorAll('.hs26-fixed');
    for(var i=0;i<els.length;i++){
      var el=els[i];
      if(el && el.parentElement !== document.body){
        document.body.appendChild(el);
      }
    }
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', moveFixedLayers);
  }else{
    moveFixedLayers();
  }
  document.addEventListener('shopify:section:load', moveFixedLayers);
})();


window.addEventListener('load', function(){
    if(window.instgrm) window.instgrm.Embeds.process();
  });

/* ═══════════════════════════════
   SNOW
═══════════════════════════════ */
(function(){
  const cv=document.getElementById('snow-cv'),cx=cv.getContext('2d');
  let W,H,fl=[];
  function resize(){W=cv.width=innerWidth;H=cv.height=innerHeight;}
  resize();addEventListener('resize',resize,{passive:true});
  function drawF(x,y,r,rot,a,t){
    cx.save();cx.translate(x,y);cx.rotate(rot);cx.globalAlpha=a;
    if(t===0){cx.beginPath();cx.arc(0,0,r,0,Math.PI*2);cx.fillStyle='rgba(255,255,255,.85)';cx.fill();}
    else if(t===1){
      cx.strokeStyle='rgba(255,255,255,.88)';cx.lineWidth=Math.max(.7,r*.17);cx.lineCap='round';
      for(let i=0;i<6;i++){cx.save();cx.rotate(Math.PI/3*i);cx.beginPath();
        cx.moveTo(0,0);cx.lineTo(0,-r);cx.moveTo(0,-r*.5);cx.lineTo(-r*.28,-r*.72);
        cx.moveTo(0,-r*.5);cx.lineTo(r*.28,-r*.72);cx.stroke();cx.restore();}
      cx.beginPath();cx.arc(0,0,r*.13,0,Math.PI*2);cx.fillStyle='rgba(255,255,255,.9)';cx.fill();
    }else{
      cx.strokeStyle='rgba(255,255,255,.62)';cx.lineWidth=Math.max(.5,r*.12);cx.beginPath();
      for(let i=0;i<6;i++){const a2=Math.PI/3*i-Math.PI/6;
        i===0?cx.moveTo(Math.cos(a2)*r,Math.sin(a2)*r):cx.lineTo(Math.cos(a2)*r,Math.sin(a2)*r);}
      cx.closePath();cx.stroke();
    }
    cx.restore();
  }
  function mkF(){const r=2.5+Math.random()*9;return{x:Math.random()*W,y:-r*2-Math.random()*H*.4,r,t:Math.floor(Math.random()*3),
    vx:(Math.random()-.5)*.5,vy:.3+Math.random()*.9+r/14,rot:Math.random()*Math.PI*2,rotV:(Math.random()-.5)*.012,
    a:.26+Math.random()*.48,sw:Math.random()*Math.PI*2,swS:.004+Math.random()*.008,swA:.4+Math.random()*.8};}
  for(let i=0;i<68;i++){const f=mkF();f.y=Math.random()*H;fl.push(f);}
  (function tick(){cx.clearRect(0,0,W,H);for(const f of fl){f.sw+=f.swS;f.x+=f.vx+Math.sin(f.sw)*f.swA;
    f.y+=f.vy;f.rot+=f.rotV;if(f.y>H+20||f.x<-20||f.x>W+20)Object.assign(f,mkF());drawF(f.x,f.y,f.r,f.rot,f.a,f.t);}
    requestAnimationFrame(tick);})();
})();

/* hero collage — static, no JS needed */

/* ═══════════════════════════════
   MOSAIC CAROUSEL — 6 per page, auto 6s
═══════════════════════════════ */
(function(){
  const track=document.getElementById('moTrack');
  const prevBtn=document.getElementById('moPrev');
  const nextBtn=document.getElementById('moNext');
  const dotsWrap=document.getElementById('moDots');
  const tabs=document.querySelectorAll('#moTabs .motab');
  const cards=[...track.querySelectorAll('.mo-card')];
  let page=0,timer=null;
  let totalPages=1;

  if(!track||!prevBtn||!nextBtn||!dotsWrap||tabs.length===0||cards.length===0) return;

  function getPageWidth(){
    /* width of 6 cards + 5 gaps */
    const visibleCards=cards.filter(card=>card.style.display!=='none');
    if(visibleCards.length===0)return 0;
    const cw=visibleCards[0].getBoundingClientRect().width;
    const gap=10;
    return (cw+gap)*6;
  }

  function renderDots(){
    dotsWrap.innerHTML='';
    for(let i=0;i<totalPages;i++){
      const dot=document.createElement('div');
      dot.className=`mo-dot${i===page?' on':''}`;
      dot.dataset.p=String(i);
      dot.addEventListener('click',()=>{
        clearInterval(timer);
        goTo(i);
        startTimer();
      });
      dotsWrap.appendChild(dot);
    }
  }

  function updateNav(){
    const showNav=totalPages>1;
    prevBtn.style.display=showNav?'':'none';
    nextBtn.style.display=showNav?'':'none';
    dotsWrap.style.display=showNav?'':'none';
  }

  function goTo(p){
    page=Math.max(0,Math.min(p,totalPages-1));
    track.style.transform=`translateX(-${page*getPageWidth()}px)`;
    dotsWrap.querySelectorAll('.mo-dot').forEach((d,i)=>d.classList.toggle('on',i===page));
    prevBtn.disabled=page===0;
    nextBtn.disabled=page===totalPages-1;
  }

  prevBtn.addEventListener('click',()=>{clearInterval(timer);goTo(page-1);startTimer();});
  nextBtn.addEventListener('click',()=>{clearInterval(timer);goTo(page+1);startTimer();});

  function startTimer(){
    clearInterval(timer);
    if(totalPages<=1) return;
    timer=setInterval(()=>{goTo(page===totalPages-1?0:page+1);},6000);
  }

  function applyFilter(cat){
    cards.forEach(card=>{
      card.style.display=card.dataset.cat===cat?'':'none';
    });
    totalPages=Math.max(1,Math.ceil(cards.filter(card=>card.style.display!=='none').length/6));
    page=0;
    renderDots();
    updateNav();
    goTo(0);
    startTimer();
  }

  /* tab filter */
  tabs.forEach(t=>{
    t.addEventListener('click',()=>{
      tabs.forEach(x=>x.classList.remove('on'));
      t.classList.add('on');
      applyFilter(t.dataset.cat);
    });
  });

  applyFilter(document.querySelector('#moTabs .motab.on').dataset.cat);
  window.addEventListener('resize',()=>goTo(page));
})();

/* ═══════════════════════════════
   PRODUCT GRID FILTER
═══════════════════════════════ */
function pFilter(cat,btn){
  document.querySelectorAll('.ctab').forEach(b=>b.classList.remove('on'));
  if(btn) btn.classList.add('on');
  document.querySelectorAll('#pgrid .pcard').forEach(c=>{
    c.style.display=(c.dataset.cat===cat)?'':'none';
  });
}

/* ═══════════════════════════════
   SCROLL REVEAL
═══════════════════════════════ */
const obs=new IntersectionObserver(es=>{
  es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('on');obs.unobserve(e.target);}});
},{threshold:.07});
document.querySelectorAll('.rv').forEach(el=>obs.observe(el));

/* ═══════════════════════════════
   NAV SHRINK
═══════════════════════════════ */
const nav=document.getElementById('sitenav');
addEventListener('scroll',()=>{nav.style.padding=scrollY>50?'9px 40px':'14px 40px';},{passive:true});

/* ── Instagram embed JS handled by external script tag ── */

/* special tabs */
document.querySelectorAll('.sptab').forEach(t=>{
  t.addEventListener('click',()=>{
    t.closest('.sp-tabs').querySelectorAll('.sptab').forEach(x=>x.classList.remove('on'));t.classList.add('on');
  });
});


(function(){
  function ensureInstagramScript(cb){
    if(window.instgrm && window.instgrm.Embeds){ cb(true); return; }
    if(document.querySelector('script[data-hs26-instagram]')){ cb(false); return; }
    var s=document.createElement('script');
    s.async=true;
    s.src='https://www.instagram.com/embed.js';
    s.setAttribute('data-hs26-instagram','1');
    s.onload=function(){ cb(true); };
    s.onerror=function(){ cb(false); };
    document.head.appendChild(s);
  }

  function processEmbedsWithRetry(){
    var tries=0, maxTries=14;
    var timer=setInterval(function(){
      tries++;
      if(window.instgrm && window.instgrm.Embeds){
        try{ window.instgrm.Embeds.process(); }catch(e){}
      }
      if(tries>=maxTries) clearInterval(timer);
    }, 600);
  }

  function run(){
    ensureInstagramScript(function(){ processEmbedsWithRetry(); });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', run);
  }else{
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
